import { useState } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import TitlePage from '../components/TitlePage';

const defaultForm = { name: '', email: '', subject: '', message: '' };

const Contact = () => {
    const [formData, setFormData] = useState(defaultForm);
    const [message, setMessage] = useState('');
    const [alert, setAlert] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [honeypot, setHoneypot] = useState('');

    const handleChange = (e: any) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (honeypot) return;

        setIsLoading(true);
        const response = await fetch('https://curly-sun-7b2c.glaminsidefashion.workers.dev', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        });

        if (response.ok) {
            setMessage('Il tuo messaggio è stato inviato. Grazie!');
            setAlert('alert-success');
            setFormData(defaultForm);
        } else {
            setMessage(`Errore durante l'invio della email!`);
            setAlert('alert-danger');
        }
        setIsLoading(false);
    };

    return (
        <>
            <Breadcrumb history={[{ title: 'Home', to: '/' }]} current='Contatti' />
            <section className='contact'>
                <TitlePage title='Contatti' />
                <div className='container' data-aos='fade-up' data-aos-delay='100'>
                    <div className='row gy-4'>
                        <div className='col-lg-5'>
                            <div className='info-wrap'>
                                <div className='info-item d-flex' data-aos='fade-up' data-aos-delay='300'>
                                    <i className='bi bi-whatsapp flex-shrink-0'></i>
                                    <div>
                                        <h3>Contattaci su WhatsApp</h3>
                                        <p>
                                            <a href='tel:+393792601719'>+39 379 260 1719</a>
                                        </p>
                                    </div>
                                </div>

                                <div className='info-item d-flex' data-aos='fade-up' data-aos-delay='400'>
                                    <i className='bi bi-envelope flex-shrink-0'></i>
                                    <div>
                                        <h3>Contattaci via email</h3>
                                        <p>
                                            <a href='mailto:info@glaminsidefashion.it'>info@glaminsidefashion.it</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-7'>
                            <form onSubmit={handleSubmit} className='row info-wrap'>
                                <div className='col-md-6 mt-3'>
                                    <label htmlFor='name' className='form-label'>
                                        Nome
                                    </label>
                                    <input
                                        id='name'
                                        type='text'
                                        name='name'
                                        className='form-control'
                                        required
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='col-md-6 mt-3'>
                                    <label htmlFor='email' className='form-label'>
                                        Email
                                    </label>
                                    <input
                                        id='email'
                                        type='email'
                                        className='form-control'
                                        name='email'
                                        required
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='col-12 mt-3'>
                                    <label htmlFor='subject' className='form-label'>
                                        Oggetto
                                    </label>
                                    <input
                                        id='subject'
                                        type='text'
                                        className='form-control'
                                        name='subject'
                                        required
                                        value={formData.subject}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='col-12 mt-3'>
                                    <label htmlFor='messageId' className='form-label'>
                                        Messaggio
                                    </label>
                                    <textarea
                                        id='messageId'
                                        className='form-control'
                                        name='message'
                                        rows={5}
                                        required
                                        value={formData.message}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>
                                <input
                                    type='text'
                                    name='honeypot'
                                    value={honeypot}
                                    className='d-none'
                                    onChange={e => setHoneypot(e.target.value)}
                                    aria-hidden='true'
                                />
                                <div className='col text-center mt-3'>
                                    <button type='submit' className='btn btn-primary' disabled={isLoading}>
                                        {isLoading && <span className='spinner-border spinner-border-sm me-2' aria-hidden='true'></span>}
                                        Invia Messaggio
                                    </button>
                                </div>
                                {message && (
                                    <div className={`alert ${alert} mt-3`} role='alert'>
                                        {message}
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default Contact;
